import SignupButton from "@component/landing/kikoff_card/signup_button";
import WaitlistButton from "@component/landing/kikoff_card/waitlist_button";

import { Flow } from "../container";

import styles from "./styles.module.scss";

function Waitlist({ flow }: { flow: Flow }) {
  return (
    <section className={styles["waitlist-section"]}>
      {flow === "waitlist" && <WaitlistButton />}
      {flow === "signup" && <SignupButton />}
      <div className={`${styles["waitlist-subtext"]} text:body-1`}>
        No credit check required
      </div>
      <div className={`${styles["legal-subtext"]} text:legal-secondary`}>
        Kikoff Inc. is a financial technology company “Fin-Tech”, not a bank.
        Kikoff Secured Credit Card provided by Coastal Community Bank, Member
        FDIC.
      </div>
    </section>
  );
}

export default Waitlist;
